export function normalizeIsActive(value: unknown): boolean | null {
  if (value === true || value === 1 || value === "1") {
    return true;
  }

  if (value === false || value === 0 || value === "0") {
    return false;
  }

  return null;
}
